var cloudinaryBaseUrls = {
  1: '//img.ving.se/image/upload',
  3: '//img.ving.no/image/upload',
  11: '//img.spies.dk/image/upload',
  15: '//img.tjareborg.fi/image/upload',
  18: '//img.globetrotter.se/image/upload'
};
var conceptUrls = {
  sunwing: 'web/concepts/sunwing-logo',
  sunprime: 'web/concepts/sunprime-logo',
  obc: 'web/concepts/obc-logo',
  familyGarden: 'web/concepts/family-garden-hotels-logo'
};
var sportUrls = {
  main: 'web/concepts/sport-logo',
  club: 'web/concepts/sport-sportsclub-logo',
  yoga: 'web/concepts/sport-yoga-logo',
  padel: 'web/concepts/sport-padel-logo',
  cycling: 'web/concepts/sport-cycling-logo',
  golf: 'web/concepts/sport-golf-logo',
  hiking: 'web/concepts/sport-hiking-logo',
  mtb: 'web/concepts/sport-mtb-logo',
  running: 'web/concepts/sport-running-logo',
  tennis: 'web/concepts/sport-tennis-logo',
  active: 'web/concepts/sport-active-logo',
  dance: 'web/concepts/sport-dance-logo',
  camp: 'web/concepts/sport-camp-logo'
};
var selectionUrls = {
  active: 'web/concepts/selection-active',
  adultsOnly: 'web/concepts/selection-adults-only',
  cityFavourite: 'web/concepts/selection-city-favourite',
  family: 'web/concepts/selection-family',
  golf: 'web/concepts/selection-golf',
  hideaway: 'web/concepts/selection-hideaway',
  nordicFavourite: 'web/concepts/selection-nordic-favourite',
  popular: 'web/concepts/selection-popular',
  romantic: 'web/concepts/selection-romantic',
  top: 'web/concepts/selection-top',
  unique: 'web/concepts/selection-unique',
  smallFriendly: 'web/concepts/selection-small-friendly'
};
var getConceptSettings = function getConceptSettings(concept) {
  var checkedConcept = concept ? concept.toLowerCase() : '';
  switch (checkedConcept) {
    case 'sunwing':
    case 'sunwingfamilyresorts':
      {
        return {
          altText: 'Sunwing',
          url: conceptUrls.sunwing,
          desktopSize: 45,
          mobileSize: 30
        };
      }
    case 'sunprime':
    case 'sunprimehotels':
      {
        return {
          altText: 'Sunprime',
          url: conceptUrls.sunprime,
          desktopSize: 45,
          mobileSize: 30
        };
      }
    case 'oceanbeachclub':
    case 'obcbysunwing':
    case 'ocean beach club':
      {
        return {
          altText: 'Ocean Beach Club',
          url: conceptUrls.obc,
          desktopSize: 45,
          mobileSize: 30
        };
      }
    case 'familygarden':
      {
        return {
          altText: 'Family Garden',
          url: conceptUrls.familyGarden,
          desktopSize: 45,
          mobileSize: 30
        };
      }
    case 'sport':
      {
        return {
          altText: 'Sport',
          url: sportUrls.main,
          desktopSize: 70,
          mobileSize: 50
        };
      }
    case 'sportsclub':
      {
        return {
          altText: 'Sports Club',
          url: sportUrls.club,
          desktopSize: 70,
          mobileSize: 50
        };
      }
    case 'sportyoga':
      {
        return {
          altText: 'Sport Yoga',
          url: sportUrls.yoga,
          desktopSize: 70,
          mobileSize: 50
        };
      }
    case 'sportpadel':
      {
        return {
          altText: 'Sport Padel',
          url: sportUrls.padel,
          desktopSize: 70,
          mobileSize: 50
        };
      }
    case 'sportcycling':
      {
        return {
          altText: 'Sport Cycling',
          url: sportUrls.cycling,
          desktopSize: 70,
          mobileSize: 50
        };
      }
    case 'sportgolf':
      {
        return {
          altText: 'Sport Golf',
          url: sportUrls.golf,
          desktopSize: 70,
          mobileSize: 50
        };
      }
    case 'sporthiking':
      {
        return {
          altText: 'Sport Hiking',
          url: sportUrls.hiking,
          desktopSize: 70,
          mobileSize: 50
        };
      }
    case 'sportmtb':
      {
        return {
          altText: 'Sport MTB',
          url: sportUrls.mtb,
          desktopSize: 70,
          mobileSize: 50
        };
      }
    case 'sportrunning':
      {
        return {
          altText: 'Sport Running',
          url: sportUrls.running,
          desktopSize: 70,
          mobileSize: 50
        };
      }
    case 'sporttennis':
      {
        return {
          altText: 'Sport Tennis',
          url: sportUrls.tennis,
          desktopSize: 70,
          mobileSize: 50
        };
      }
    case 'sportactive':
      {
        return {
          altText: 'Sport Active',
          url: sportUrls.active,
          desktopSize: 70,
          mobileSize: 50
        };
      }
    case 'sportdance':
      {
        return {
          altText: 'Sport Dance',
          url: sportUrls.dance,
          desktopSize: 70,
          mobileSize: 50
        };
      }
    case 'sportcamp':
      {
        return {
          altText: 'Sport Camp',
          url: sportUrls.camp,
          desktopSize: 70,
          mobileSize: 50
        };
      }
    case 'activeselection':
      return {
        altText: 'Active Selection',
        url: selectionUrls.active,
        desktopSize: 44,
        mobileSize: 44 * 0.65,
        svgSources: true
      };
    case 'adultonlyselection':
      return {
        altText: 'Adults Only Selection',
        url: selectionUrls.adultsOnly,
        desktopSize: 47,
        mobileSize: 47 * 0.65,
        svgSources: true
      };
    case 'cityfavouriteselection':
      return {
        altText: 'City Favourite Selection',
        url: selectionUrls.cityFavourite,
        desktopSize: 49,
        mobileSize: 49 * 0.65,
        svgSources: true
      };
    case 'familyselection':
      return {
        altText: 'Family Selection',
        url: selectionUrls.family,
        desktopSize: 42,
        mobileSize: 42 * 0.65,
        svgSources: true
      };
    case 'golfselection':
      return {
        altText: 'Golf Selection',
        url: selectionUrls.golf,
        desktopSize: 41,
        mobileSize: 41 * 0.65,
        svgSources: true
      };
    case 'hideawayselection':
      return {
        altText: 'Hideaway Selection',
        url: selectionUrls.hideaway,
        desktopSize: 45,
        mobileSize: 45 * 0.65,
        svgSources: true
      };
    case 'nordicfavouriteselection':
    case 'nordic selection':
    case 'nordicselection':
    case 'nordicfavourites':
    case 'nordiskafavoriter':
    case 'pohjoismaisetsuosikit':
    case 'nordiskefavoritter':
      return {
        altText: 'Nordic Favourite Selection',
        url: selectionUrls.nordicFavourite,
        desktopSize: 51,
        mobileSize: 51 * 0.65,
        svgSources: true
      };
    case 'popularselection':
      return {
        altText: 'Popular Selection',
        url: selectionUrls.popular,
        desktopSize: 43,
        mobileSize: 43 * 0.65,
        svgSources: true
      };
    case 'romanticselection':
      return {
        altText: 'Romantic Selection',
        url: selectionUrls.romantic,
        desktopSize: 45,
        mobileSize: 45 * 0.65,
        svgSources: true
      };
    case 'topselection':
    case 'topselectionfamily':
    case 'topselectionadult':
    case 'topselectionothers':
    case 'signature':
    case 'signature_t':
    case 'topselectionother':
    case 'topselectionförvuxna':
    case 'topselectionforvoksne':
    case 'topselectionaikuisille':
    case 'topselectionförfamiljer':
    case 'topselectionforfamilier':
    case 'topselectionforfamilien':
    case 'topselectionperheille':
    case 'topselectionföralla':
    case 'topselectionforalle':
    case 'topselectionkaikille':
      return {
        altText: 'Top Selection',
        url: selectionUrls.top,
        desktopSize: 39,
        mobileSize: 39 * 0.65,
        svgSources: true
      };
    case 'uniqueselection':
      return {
        altText: 'Unique Selection',
        url: selectionUrls.unique,
        desktopSize: 43,
        mobileSize: 43 * 0.65,
        svgSources: true
      };
    case 'smallandfriendlyselection':
    case 'small&friendlyselection':
    case 218:
      return {
        altText: 'Small and Friendly Selection',
        url: selectionUrls.smallFriendly,
        desktopSize: 49,
        mobileSize: 49 * 0.65,
        svgSources: true
      };
    default:
      {
        return null;
      }
  }
};

export { cloudinaryBaseUrls, getConceptSettings };
//# sourceMappingURL=utils.js.map
